<template>
    <div class="sumbit-form">
        <el-form :ref="ref" class="form" :model="value" :rules="rules" :key="ref">
            <div v-for="(item,index) in list" :key="index" class="item">
                <template v-if="item.type == 'input'||item.type == 'number'||item.type == 'password'">
                    <el-form-item :label="item.label" :label-width="labelWidth" :prop="item.name">
                        <el-input v-model="value[item.name]" placeholder="请输入" :type="item.type" style="width:215px" size="small"></el-input>
                    </el-form-item>
                </template>
                <template v-if="item.type == 'textarea'">
                    <el-form-item :label="item.label" :label-width="labelWidth" :prop="item.name">
                        <el-input v-model="value[item.name]" placeholder="请输入" :type="item.type" :rows="item.row" :style="'width:'+(item.valueWidth?item.valueWidth:'550px')" size="small"></el-input>
                    </el-form-item>
                </template>
                <template v-if="item.type == 'select'">
                    <el-form-item :label="item.label" :label-width="labelWidth" :prop="item.name">
                        <el-select v-model="value[item.name]" placeholder="请选择" size="small" filterable>
                            <el-option
                            v-for="oitem in item.options"
                            :key="oitem[item.optionsValue?item.optionsValue:'value']"
                            :label="oitem[item.optionsLable?item.optionsLable:'label']"
                            :value="oitem[item.optionsValue?item.optionsValue:'value']">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </template>

                <template v-if="item.type == 'selectList'">
                    <el-form-item :label="item.label" :label-width="labelWidth" :prop="item.name">
                        <el-select v-model="value[item.name]" placeholder="请选择" multiple size="small" filterable>
                            <el-option
                            v-for="oitem in item.options"
                            :key="oitem[item.optionsValue?item.optionsValue:'value']"
                            :label="oitem[item.optionsLable?item.optionsLable:'label']"
                            :value="oitem[item.optionsValue?item.optionsValue:'value']">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </template>
                <template v-if="item.type == 'selectBtn'">
                    <el-form-item :label="item.label" :label-width="labelWidth" :prop="item.name">
                        <el-input v-model="value[item.name]" placeholder="请输入" :type="item.type" :rows="item.row" :style="'width:215px'" size="small" disabled></el-input>
                        <el-button type="primary" size="small" @click="item.btnFunction">{{item.btnName}}</el-button>
                    </el-form-item>
                </template>

                <template v-if="item.type == 'address'">
                    <el-form-item :label="item.label" :label-width="labelWidth" :prop="item.name">
                        <el-cascader
                        size="small"
                        placeholder="请选择"
                        :options="regionData"
                        v-model="value[item.name]"
                        >
                        </el-cascader>
                    </el-form-item>
                </template>
                <template v-if="item.type == 'dateList'">
                    <el-form-item :label="item.label" :label-width="labelWidth" :prop="item.name">
                        <el-date-picker
                        size="small"
                        v-model="value[item.name]"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                    >
                        </el-date-picker>
                    </el-form-item>
                </template>
                
                <template v-if="item.type == 'date'">
                    <el-form-item :label="item.label" :label-width="labelWidth" :prop="item.name">
                        <el-date-picker
                        size="small"
                        v-model="value[item.name]"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="请选择日期"
                    >
                        </el-date-picker>
                    </el-form-item>
                </template>

                <template v-if="item.type == 'datetime'">
                    <el-form-item :label="item.label" :label-width="labelWidth" :prop="item.name">
                        <el-date-picker
                        size="small"
                        v-model="value[item.name]"
                        type="datetime"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="请选择日期"
                    >
                        </el-date-picker>
                    </el-form-item>
                </template>

                <template v-if="item.type == 'switch'">
                    <el-form-item :label="item.label" :label-width="labelWidth" :prop="item.name">
                        <!-- <el-date-picker
                        size="small"
                        v-model="value[item.name]"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="请选择日期"
                    >
                        </el-date-picker> -->
                        <el-switch v-model="value[item.name]"></el-switch>
                    </el-form-item>
                </template>
                
                <el-form-item :label="item.label" :label-width="labelWidth" :prop="item.name" v-if="item.type == 'checkbox'">
                    <el-checkbox-group v-model="value[item.name]">
                        <el-checkbox :label="row.label" v-for="(row,index) in item.options" :key="index"></el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
            </div>

            <div class="btns">
                <el-button
                    v-for="(item, index) in btns"
                    :key="index"
                    size="small"
                    :type="item.type"
                    :icon="item.icon"
                    @click.stop.prevent="item.handleClick"
                    >{{ item.name }}
                </el-button>
            </div>
            
        </el-form>
    </div>
</template>

<script>
    import { regionData , CodeToText } from "element-china-area-data";
    export default {
        computed: {
        },
        data() {
            return {
                
                regionData:regionData,
                isSearchLock: true,
                
            }
        },
        props:{
            ref:{
                type: String,
                default: 'formList'
            },
            list:{
                type: Array,
                default: () => []
            },
            rules: {
                type: Object,
                default: () => {}
            },
            value: {
                type: Object,
                default: () => {}
            },
            labelWidth:{
                type: String,
                default: '150px'
            },
            btns:{
                type: Array,
                default: () => []
            },
           
            

        },
        
        watch: {
            
        },
        created() {

        },
        mounted() {
           
        },
        methods: {
            
            //子组件校验，传递到父组件
            validateForm() {
                let flag = null;
                if (this.isSearchLock) {
                    this.$refs[this.ref].validate(valid => {
                    let vm = this;
                    if (valid) {
                        flag = true;
                        vm.isSearchLock = flag;
                    } else {
                        flag = false;
                        vm.isSearchLock = flag;
                        this.$message.error("信息不完整，请继续填写完整");
                        setTimeout(function() {
                            vm.isSearchLock = true;
                        }, 2000);
                    }
                    });
                    return flag;
                }
            },
            resetFields() {
                console.log(this.ref);
                this.$refs[this.ref].resetFields();
            }
        }

    }
</script>

<style lang="scss" scoped>
    .form{
        display: flex;
        flex-wrap: wrap;
        .item{
            display: flex;
        }
        .btns{
            width: 100%;
            display: flex;
            justify-content: center;
            /deep/.el-button{
                font-size: 14px;
                // margin: 0 10px;
            }
        }
    }
    /deep/.el-input.is-disabled .el-input__inner{
        color: #606266;
    }
</style>